// extracted by mini-css-extract-plugin
export default {"bell":"no-purify__notificationsButton__bell___qQ8BW","badge":"no-purify__notificationsButton__badge___dvDAV"};